module.exports = "/_next/static/resources/photo-1-ef3eab919f3a62d5c1f43b1f93fdf81b.webp";